import React, { useEffect, useState } from "react";
import { FormSection } from "./FormSection";
import { Box } from "@mui/material";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { useGetCitiesQuery } from "../../api/admin/categoriesApi";
import {
  useCreateCompanyMutation,
  useDeleteCompanyMutation,
  useEditCompanyMutation,
  useGetAtecoCodeQuery,
} from "../../api/admin/adminCompany";

import { useNavigate } from "react-router-dom";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import { toast } from "react-toastify";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useGetServicesQuery } from "../../api/admin/ServiziApi";
import { isEmailValid } from "../../../utils/functions/form";
import { useCreateUserMutation } from "../../api/admin/gestisciUtentiApi";
import { useSelector } from "react-redux";
import { ROLE } from "../../../utils/constants/profiles";
import { t } from "i18next";
import { useGetProfileCategoryQuery } from "../../api/admin/gestioneNewsApi";
import {
  useGetStudioIdQuery,
  useGetStudiosQuery,
} from "../../api/admin/gestisciStudioApi";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import MultipleUser from "./MultipleUser/MultipleUser";
import CoreBack from "../../../app/core/components/CoreBack/CoreBack";
import AssociateTableUserCompany from "./AssociateTableUserCompany";

export const FormCompany = ({ isEdit, companyToEdit, userData }) => {
  const navigate = useNavigate();
  const studioId = useSelector((state) => state.app.studioId);
  const adminId = useSelector((state) => state.app.adminId);
  const role = useSelector((state) => state.app.role);

  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [validationMultipleUserErrors, setValidationMultipleUserErrors] =
    useState([]);
  const [aziendaData, setAziendaData] = useState({
    anagrafeCode: "",
    name: "",
    vat: null,
    fiscalCode: "",
    address: "",
    houseNumber: "",
    postalCode: "",
    phoneNumber: "",
    email: "",
    pecLegale: "",
    opAddress: "",
    opHouseNumber: "",
    opPostalCode: "",
    opPhoneNumber: "",
    opEmail: "",
    nomeRef: "",
    cognomeRef: "",
    studioRef: undefined,
    operatorRef: "",
    multipleUser: [],
    atecoCodeId: null,
    codiceAtecoDescription: "",
    servicesId: [],
  });
  const [showConfirmCompanyDialog, setShowConfirmCompanyDialog] =
    useState(false);

  const [isEqualHeadquarters, setIsEqualHeadquarters] = useState(true);

  const [deleteCompany, { isLoading: isLoadingDelete }] =
    useDeleteCompanyMutation();
  const [editCompany, { isLoading: isLoadingSave }] = useEditCompanyMutation();
  const [createUser] = useCreateUserMutation();

  const { data: dataListCategory } = useGetProfileCategoryQuery(undefined, {
    skip: isEdit,
  });
  const { data } = useGetAtecoCodeQuery();
  const { data: companyServicesOptions } = useGetServicesQuery({
    currentPage: 1,
    startRow: 0,
    endRow: 50,
  });
  const { data: studios } = useGetStudiosQuery({
    ...{ currentPage: 1, startRow: 0, endRow: TABLE_ROWS_NUMBER },
    value: debouncedInputStudioValue,
  });
  const { data: operatorsData } = useGetStudioIdQuery(
    aziendaData?.studioRef?.id,
    {
      skip: !aziendaData.studioRef,
    }
  );

  const operatorOptions = operatorsData?.Data?.admins?.map((user) => ({
    label: `${user?.name} ${user.surname}`,
    value: user?.id,
  }));
  const [createCompany, { isLoading: isLoadingCreate }] =
    useCreateCompanyMutation();

  useEffect(() => {
    if (companyToEdit && isEdit) {
      setAziendaData({
        ...companyToEdit,
        comuneLegale: companyToEdit.city,
        comuneOperativo: companyToEdit.opCity,
      });
    }
  }, [companyToEdit, isEdit]);

  const atecoOptions =
    (data &&
      data.Data &&
      data.Data.map((el) => ({
        label: el?.code,
        value: el?.id,
      }))) ||
    [];

  const handleInputChange = (e) => {
    const { name, checked, type } = e.target;
    const value = type === "checkbox" ? checked : e.target.value;
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
    setAziendaData({
      ...aziendaData,
      [name]: value,
    });
  };

  const handleInputChangeAuto = (event, newValue) => {
    setAziendaData((prevData) => ({
      ...prevData,
      comuneLegale: {
        name: newValue ? newValue.name : "",
        cadastralCode: newValue ? newValue.cadastralCode : "",
      },
    }));
  };

  const handleInputChangeAutoOp = (event, newValue) => {
    setAziendaData((prevData) => ({
      ...prevData,
      comuneOperativo: {
        name: newValue ? newValue.name : "",
        cadastralCode: newValue ? newValue.cadastralCode : "",
      },
    }));
  };

  const handleStudioChange = (valueObj) => {
    if (!valueObj) setAziendaData((prev) => ({ ...prev, operatorRef: "" }));
    setAziendaData((prev) => ({ ...prev, studioRef: valueObj }));
    setValidationErrors((prev) => ({ ...prev, studioRef: "" }));
  };

  const handleMultipleUserChange = (newValue) => {
    setAziendaData((prev) => ({ ...prev, multipleUser: newValue }));
  };

  const handleMultipleUserValidationErrorsChange = (newValue) => {
    setValidationMultipleUserErrors(newValue);
  };

  const handleSubmit = () => {
    setValidationErrors({});
    setValidationMultipleUserErrors([]);
    const errors = {};
    const multipleUserErrors = Array.from(
      { length: aziendaData?.multipleUser?.length || 0 },
      () => ({}) //creo un array di oggetti vuoti (*che non puntano allo stesso oggetto) tanti quanti sono i referenti aggiuntivi nel form
    );
    if (!aziendaData.name) errors.name = t("FieldRequired");
    if (!isEdit) {
      if (!aziendaData.nomeRef) errors.nomeRef = t("FieldRequired");
      if (!aziendaData.cognomeRef) errors.cognomeRef = t("FieldRequired");
      if (!aziendaData.studioRef && role === ROLE.ADMIN)
        errors.studioRef = t("FieldRequired");
    }
    if (!isEmailValid(aziendaData.email)) errors.email = t("InsertValidMail");

    for (let i = 0; i < (aziendaData?.multipleUser?.length || 0); i++) {
      if (!aziendaData.multipleUser[i].nome?.trim())
        multipleUserErrors[i].nome = t("FieldRequired");
      if (!aziendaData.multipleUser[i].cognome?.trim())
        multipleUserErrors[i].cognome = t("FieldRequired");
      if (!isEmailValid(aziendaData.multipleUser[i].email))
        multipleUserErrors[i].email = t("InsertValidMail");
      if (!aziendaData.multipleUser[i].occupazione)
        multipleUserErrors[i].occupazione = t("FieldRequired");
      if (
        !aziendaData.multipleUser[i].studio &&
        role === ROLE.ADMIN &&
        !aziendaData.multipleUser[i].sameRefStudio
      )
        multipleUserErrors[i].studio = t("FieldRequired");
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    for (let i = 0; i < multipleUserErrors.length; i++) {
      let errorObj = multipleUserErrors[i];
      if (Object.keys(errorObj).length > 0) {
        setValidationMultipleUserErrors(multipleUserErrors);
        return;
      }
    }
    const operationalHeadquarter = isEqualHeadquarters
      ? {
          opAddress: aziendaData.address,
          opHouseNumber: aziendaData.houseNumber,
          opPostalCode: aziendaData.postalCode,
          opPhoneNumber: aziendaData.phoneNumber,
          opEmail: aziendaData.email,
        }
      : {};
    const body = {
      ...aziendaData,
      ...operationalHeadquarter,
      cityId: aziendaData?.comuneLegale?.cadastralCode,
      opCityId: isEqualHeadquarters
        ? aziendaData?.comuneLegale?.cadastralCode
        : aziendaData?.comuneOperativo?.cadastralCode,
    };
    const mainUserData = {
      name: aziendaData.nomeRef,
      surname: aziendaData.cognomeRef,
      email: aziendaData.email,
      fiscalCode: aziendaData.codiceFiscaleRef,
      employmentStatusId: dataListCategory?.Data.find(
        (el) => el.name === "Referente principale"
      )?.id,
      studioId:
        role !== ROLE.ADMIN
          ? studioId
          : aziendaData.studioRef
          ? aziendaData.studioRef.id
          : null,
      adminId:
        role !== ROLE.ADMIN
          ? adminId
          : aziendaData.operatorRef
          ? aziendaData.operatorRef
          : null,
      // adminProfileRoles: []
    };

    if (isEdit) {
      const { city, opCity, comuneLegale, comuneOperativo, ...clearBody } =
        body;
      editCompany(clearBody)
        .then((res) => {
          if (res?.data?.Result !== 1) {
            toast.error(res?.data?.Exception || t("CompanyNotUpdated"));
            return;
          }
          toast.success(t("CompanyUpdated"));
        })
        .catch(() => toast.error(t("CompanyNotUpdated")));
      return;
    }
    const id = toast.loading(t("Creation..."), {
      type: "info",
    });
    const { services, ...clearBody } = body;
    createCompany(clearBody)
      .then(async (res) => {
        if (res?.data?.Result !== 1) {
          toast.update(id, {
            render: res?.data?.Exception || t("CompanyNotCreated"),
            type: "error",
            autoClose: 1500,
            isLoading: false,
          });
          return;
        }

        createUser({ ...mainUserData, userCompanyId: res.data.Data.id }).then(
          (res) => {
            if (res.data.Result !== 1) {
              toast.error(res.data.Exception);
              return;
            }
          }
        );
        if (aziendaData.multipleUser.length > 0) {
          try {
            const promises = aziendaData.multipleUser.map(async (el) => {
              const secondaryUserData = {
                name: el.nome,
                surname: el.cognome,
                email: el.email,
                fiscalCode: el.codiceFiscale,
                employmentStatusId: el.occupazione,
                studioId:
                  role === ROLE.ADMIN
                    ? el.sameRefStudio
                      ? mainUserData.studioId
                      : el.studio
                    : studioId,
                adminId:
                  role === ROLE.ADMIN
                    ? el.sameRefStudio
                      ? mainUserData.adminId
                      : el.commercialista || null
                    : adminId,
              };
              await createUser({
                ...secondaryUserData,
                userCompanyId: res.data.Data.id,
              }).then((res) => {
                if (res.data.Result !== 1) {
                  toast.error(res.data.Exception);
                }
              });
            });

            await Promise.all(promises);
          } catch (error) {
            console.error("Errore nella chiamata API:", error);
          }
        }

        toast.update(id, {
          render: t("CompanyCreated"),
          type: "success",
          autoClose: 2000,
          isLoading: false,
        });
        navigate(-1);
      })
      .catch(() =>
        toast.update(id, {
          render: t("CompanyNotCreated"),
          type: "error",
          autoClose: 1500,
          isLoading: false,
        })
      );
  };
  //ELIMINAZIONE
  const handleConfirmDialog = () => {
    setShowConfirmCompanyDialog(true);
  };

  const handleCloseDialog = () => {
    setShowConfirmCompanyDialog(false);
  };

  const handleDeleteCompany = () => {
    deleteCompany(aziendaData.id)
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.error(res.data?.Exception || t("CompanyNotDeleted"));
          return;
        }
        toast.success(t("CompanyDeleted"));
        handleCloseDialog();
        navigate(-1);
      })
      .catch(() => toast.error(t("CompanyNotDeleted")));
  };

  return (
    <div className="flex flex-col">
      <div className="flex justify-center w-full items-center">
        <CoreBack />
        <div className="w-11/12 flex items-center justify-between">
          <h2 className="font-bold">
            {isEdit ? t("Edit") : t("Create")} {t("Company")}
          </h2>
        </div>
      </div>

      {isEdit && (
        <AssociateTableUserCompany
          userData={userData}
          dataListCategory={dataListCategory}
        />
      )}
      <div className="flex space-x-8 mt-10">
        <FormSection
          title="DATI AZIENDA"
          fields={[
            {
              label: t("CompanyCode"),
              name: "anagrafeCode",
              type: "text",
              value: aziendaData.anagrafeCode,
              onChange: handleInputChange,
              required: false,
              error: validationErrors.anagrafeCode,
              className: "w-1/2 mt-2",
            },
            {
              label: t("CompanyName"),
              name: "name",
              type: "text",
              value: aziendaData.name,
              onChange: handleInputChange,
              required: true,
              error: validationErrors.name,
              className: "w-1/2 mt-2",
            },
            {
              label: t("VAT"),
              name: "vat",
              type: "text",
              value: aziendaData.vat,
              onChange: handleInputChange,
              required: false,
              error: validationErrors.vat,
              className: "w-1/2 mt-2",
            },
            {
              label: t("CF"),
              name: "fiscalCode",
              type: "text",
              value: aziendaData.fiscalCode,
              onChange: handleInputChange,
              required: false,
              error: validationErrors.fiscalCode,
              className: "w-1/2 mt-2",
            },
            {
              label: t("Studio"),
              name: "studio",
              type: "selectStudio",
              value: aziendaData.studioRef,
              onChange: handleStudioChange,
              setDebouncedValue: setDebouncedInputStudioValue,
              items: studios?.Data?.items,
              required: true,
              error: validationErrors.studioRef,
              className: "w-1/2 mt-6",
            },
            {
              label: t("Operator"),
              name: "operatorRef",
              type: "coreSelectObjArr",
              value: aziendaData.operatorRef,
              onChange: handleInputChange,
              items: operatorOptions,
              required: false,
              error: validationErrors.operatorRef,
              disabled: !aziendaData.studioRef,
              className: "w-full mt-2",
            },
          ].filter((e) => {
            if (
              ["operatorRef", "studio"].includes(e.name) &&
              (isEdit || role !== ROLE.ADMIN)
            )
              return false;
            return true;
          })}
        />
        <FormSection
          title={t("Title2")}
          fields={[
            {
              label: t("CompanyStreet"),
              name: "address",
              type: "text",
              value: aziendaData.address,
              onChange: handleInputChange,
              required: false,
              error: validationErrors.address,
              className: "w-1/2 mt-2",
            },
            {
              label: t("CompanyStreetNumber"),
              name: "houseNumber",
              type: "text",
              value: aziendaData.houseNumber,
              onChange: handleInputChange,
              required: false,
              error: validationErrors.houseNumber,
              className: "w-1/2 mt-2",
            },
            {
              label: t("City"),
              name: "comuneLegale",
              type: "select",
              value: aziendaData?.comuneLegale?.name,
              fetch: useGetCitiesQuery,
              onChange: handleInputChangeAuto,
              required: false,
              error: validationErrors.comuneLegale,
              className: "w-1/2 mt-4",
            },
            {
              label: t("PostalCode"),
              name: "postalCode",
              type: "text",
              value: aziendaData.postalCode,
              onChange: handleInputChange,
              required: false,
              error: validationErrors.postalCode,
              className: "w-1/2 mt-2",
            },
            {
              label: t("Phone"),
              name: "phoneNumber",
              type: "text",
              value: aziendaData.phoneNumber,
              onChange: handleInputChange,
              required: false,
              error: validationErrors.phoneNumber,
              className: "w-1/2 mt-2",
            },
            {
              label: "Email",
              name: "email",
              type: "email",
              value: aziendaData.email,
              onChange: handleInputChange,
              required: false,
              error: validationErrors.email,
              className: "w-1/2 mt-2",
            },
            {
              label: t("Pec"),
              name: "pecLegale",
              type: "text",
              value: aziendaData.pecLegale,
              onChange: handleInputChange,
              required: false,
              error: validationErrors.pecLegale,
              className: "w-1/2 mt-2",
            },
            { name: "emptyDiv", type: "emptyDiv", className: "w-1/2 mt-2" },
          ].filter((e) => {
            if (["emptyDiv", "email"].includes(e.name)) return false;
            return true;
          })}
        />
      </div>
      <div className="flex space-x-8 mt-10">
        <FormSection
          title={t("Title3")}
          isEqualHeadquartersCheckbox={
            <FormControlLabel
              control={
                <Checkbox
                  checked={isEqualHeadquarters}
                  onChange={() => setIsEqualHeadquarters((prev) => !prev)}
                />
              }
              label={t("HeadquarterMatch")}
            />
          }
          fields={
            isEqualHeadquarters
              ? []
              : [
                  {
                    label: t("CompanyStreet"),
                    name: "opAddress",
                    type: "text",
                    value: aziendaData.opAddress,
                    onChange: handleInputChange,
                    required: false,
                    error: validationErrors.opAddress,
                    className: "w-1/2 mt-2",
                  },
                  {
                    label: t("CompanyStreetNumber"),
                    name: "opHouseNumber",
                    type: "text",
                    value: aziendaData.opHouseNumber,
                    onChange: handleInputChange,
                    required: false,
                    error: validationErrors.opHouseNumber,
                    className: "w-1/2 mt-2",
                  },
                  {
                    label: t("City"),
                    name: "comuneOperativo",
                    type: "select",
                    value: aziendaData?.comuneOperativo?.name,
                    fetch: useGetCitiesQuery,
                    onChange: handleInputChangeAutoOp,
                    required: false,
                    error: validationErrors.comuneOperativo,
                    className: "w-1/2 mt-4",
                  },
                  {
                    label: t("PostalCode"),
                    name: "opPostalCode",
                    type: "text",
                    value: aziendaData.opPostalCode,
                    onChange: handleInputChange,
                    required: false,
                    error: validationErrors.opPostalCode,
                    className: "w-1/2 mt-2",
                  },
                  {
                    label: t("Phone"),
                    name: "opPhoneNumber",
                    type: "text",
                    value: aziendaData.opPhoneNumber,
                    onChange: handleInputChange,
                    required: false,
                    error: validationErrors.opPhoneNumber,
                    className: "w-1/2 mt-2",
                  },
                  {
                    label: "Email",
                    name: "opEmail",
                    type: "email",
                    value: aziendaData.opEmail,
                    onChange: handleInputChange,
                    required: false,
                    error: validationErrors.opEmail,
                    className: "w-1/2 mt-2",
                  },
                ]
          }
        />
        <FormSection
          title={t("Title5")}
          fields={[
            {
              label: t("AtecoCode"),
              name: "atecoCodeId",
              type: "coreSelectObjArr",
              value: aziendaData?.atecoCodeId,
              items: [{ label: "Nessuno", value: null }, ...atecoOptions],
              onChange: handleInputChange,
              required: false,
              error: validationErrors.atecoCodeId,
            },
            {
              disabled: true,
              label: t("AtecoDescription"),
              type: "text",
              name: "codiceAtecoDescription",
              value: !aziendaData.atecoCodeId
                ? ""
                : aziendaData.codiceAtecoDescription ||
                  data?.Data?.find((e) => e.id === aziendaData.atecoCodeId)
                    ?.description,
              className: "w-1/2 mt-2",
            },
          ]}
        />
      </div>
      {!isEdit && (
        <div className="mt-10">
          <FormSection
            title={t("Title4")}
            fields={[
              {
                label: t("RefName"),
                name: "nomeRef",
                type: "text",
                value: aziendaData?.nomeRef,
                onChange: handleInputChange,
                required: true,
                error: validationErrors.nomeRef,
                className: "w-1/2 mt-2",
              },
              {
                label: t("RefSurname"),
                name: "cognomeRef",
                type: "text",
                value: aziendaData?.cognomeRef,
                onChange: handleInputChange,
                required: true,
                error: validationErrors.cognomeRef,
                className: "w-1/2 mt-2",
              },
              {
                label: t("RefEmail"),
                name: "email",
                type: "email",
                value: aziendaData.email,
                onChange: handleInputChange,
                required: true,
                error: validationErrors.email,
                className: "w-1/2 mt-2",
              },
              {
                label: t("RefCF"),
                name: "codiceFiscaleRef",
                type: "text",
                value: aziendaData?.codiceFiscaleRef,
                onChange: handleInputChange,
                error: validationErrors.codiceFiscaleRef,
                className: "w-1/2 mt-2",
              },
            ]}
          />
          <MultipleUser
            formFields={aziendaData.multipleUser}
            setFormFields={handleMultipleUserChange}
            setValidationFormFieldsErrors={
              handleMultipleUserValidationErrorsChange
            }
            validationFormFieldsErrors={validationMultipleUserErrors}
          />
        </div>
      )}

      <Box
        sx={{
          width: "100%",
          textAlign: "left",
        }}
      >
        {isEdit ? (
          <div className="flex w-full justify-around mt-8">
            <CoreButton
              testo={t("Delete")}
              className="bg-red-700 btn-round border-red-700"
              onClick={handleConfirmDialog}
            />
            <CoreButton
              testo={t("Save")}
              className="btn-round"
              onClick={handleSubmit}
              disabled={isLoadingSave}
            />
          </div>
        ) : (
          <div className="w-full flex justify-center mt-10">
            <CoreButton
              className={"btn-round"}
              variant="contained"
              testo={t("Create")}
              onClick={handleSubmit}
              disabled={isLoadingCreate}
            />
          </div>
        )}
      </Box>

      <CoreDialog
        open={showConfirmCompanyDialog}
        title={`${t("Delete")} ${t("company")}`}
        content={`${t("CompanyDeletingConfirm")} ${aziendaData.name}?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        disabledButton={isLoadingDelete}
        handlePositive={handleDeleteCompany}
        closeDialog={handleCloseDialog}
      />
    </div>
  );
};
